/**
 * organizations Actions
 */
import { AxiosError, AxiosResponse } from 'axios';
import {
    ORGANIZATIONS_LOAD_REQUESTED,
    ORGANIZATIONS_LOAD_SUCCEEDED,
    ORGANIZATIONS_LOAD_FAILED,
    NEW_ORGANIZATION_REQUESTED,
    NEW_ORGANIZATION_SUCCEEDED,
    NEW_ORGANIZATION_FAILED
} from './constants';
import {
    FailedNewOrganizationAction,
    LoadOrganizationsAction,
    NewOrganizationPayload,
    OrganizationsLoadedAction,
    OrganizationsLoadingErrorAction,
    RequestedNewOrganizationAction,
    SucceededNewOrganizationAction
} from './types';

export function loadOrganizations(): LoadOrganizationsAction {
    return {
        type: ORGANIZATIONS_LOAD_REQUESTED,
        meta: {
            logentries: true
        }
    };
}

export function organizationsLoaded(
    response: AxiosResponse
): OrganizationsLoadedAction {
    return {
        type: ORGANIZATIONS_LOAD_SUCCEEDED,
        payload: response,
        meta: {
            schemaName: 'organizations'
        }
    };
}

export function organizationsLoadingError(
    error: Error
): OrganizationsLoadingErrorAction {
    return {
        type: ORGANIZATIONS_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function requestedNewOrganization(
    payload: NewOrganizationPayload
): RequestedNewOrganizationAction {
    return {
        type: NEW_ORGANIZATION_REQUESTED,
        payload,
        meta: {
            logentries: true
        }
    };
}

export function succeededNewOrganization(
    response: AxiosResponse
): SucceededNewOrganizationAction {
    return {
        type: NEW_ORGANIZATION_SUCCEEDED,
        payload: response,
        meta: {
            logentries: true
        }
    };
}

export function failedNewOrganization(
    error: AxiosError
): FailedNewOrganizationAction {
    return {
        type: NEW_ORGANIZATION_FAILED,
        payload: error,
        error: true,
        meta: {
            logentries: true
        }
    };
}
